import { createContext } from 'react';
import Fund from '@/models/Fund';
import Balance from '@/models/Balance';

interface FundContextValue {
  currentFund: Fund | null;
  balance: Balance | null;
}

const FundContext = createContext<FundContextValue | undefined>(undefined);
export default FundContext;
